import React from 'react'
import Carousel from 'react-material-ui-carousel'
import colors from '../../tokens/colors'
import {
  SlideContainer,
  SlideContent,
  Title,
  Description,
  Category,
  Button,
  styles,
} from './styles'

export interface CarouselProps {
  category: string
  buttonText: string
  description: string
  title: string
  externalUrl?: string
  imageUrl: string
}

export interface Theme {
  primaryPure: string
  primaryLight: string
}

type Props = {
  slides: CarouselProps[]
  theme?: Theme
}
/**
 *
 * @deprecated This will be removed in the future
 */

const CarouselSlider: React.FC<Props> = (props: Props) => {
  const { slides, theme } = props

  const defaultBrandColors = {
    primaryPure: colors.brandColorPrimaryPure,
    primaryLight: colors.brandColorPrimaryLight,
    primaryMedium: colors.brandColorPrimaryMedium,
    primaryDark: colors.brandColorPrimaryDark,
  }

  const defineColor = (primaryColor: string) => {
    return theme ? theme[primaryColor] : defaultBrandColors[primaryColor]
  }

  return (
    <Carousel
      indicatorContainerProps={styles.indicatorContainer}
      indicatorIconButtonProps={styles.indicatorIcon(
        defineColor('primaryPure'),
      )}
      activeIndicatorIconButtonProps={styles.activeIndicatorIcon(
        defineColor('primaryPure'),
      )}
      navButtonsAlwaysInvisible={true}
      autoPlay={true}
      animation="slide"
    >
      {slides.map((slide, index) => (
        <SlideContainer
          key={index}
          img={slide.imageUrl}
          brandColor={defineColor('primaryLight')}
        >
          <SlideContent>
            <Category brandColor={defineColor('primaryPure')}>
              {slide.category}
            </Category>
            <Title>{slide.title}</Title>
            <Description>{slide.description}</Description>
            <Button
              href={slide.externalUrl}
              brandColorPure={defineColor('primaryPure')}
              brandColorMedium={defineColor('primaryMedium')}
              brandColorDark={defineColor('primaryDark')}
            >
              {slide.buttonText}
            </Button>
          </SlideContent>
        </SlideContainer>
      ))}
    </Carousel>
  )
}

export default CarouselSlider
